<div *ngIf="this.loader.loading | async as isLoading">
  @if(isLoading){
    <div class="cssload-container" [ngClass]="{ 'is-admin': isAdmin}">
      <div class="css-speeding-wheel-wrapper">
        <div class="css-speeding-wheel"></div>
      </div>
    </div>
  }
</div>

